module.exports = __webpack_public_path__ + "static/media/rec_point2.bbcf85d6.svg";